/*
 * Button feedback for `snippets/fk-add-to-cart.liquid`.
 *
 * The add itself is Ritual's `product-form-component`; it tells the rest of
 * the theme through `shopify:cart:lines-update` (whose `promise` settles when
 * the cart has answered) and `shopify:cart:error`. Both bubble from the form
 * component, so one listener each on the document covers every card.
 */

const ADDED_FOR = 2000;

/** @param {EventTarget | null} target */
function buttonFor(target) {
  if (!(target instanceof Element)) return null;
  return target.closest('.fk-atc')?.querySelector('.fk-atc__button') ?? null;
}

/** @param {HTMLButtonElement} button @param {string} state */
function setState(button, state) {
  const label = button.querySelector('.fk-atc__label');
  if (label && !button.dataset.label) button.dataset.label = label.textContent ?? '';

  button.classList.toggle('is-busy', state === 'busy');
  button.classList.toggle('is-added', state === 'added');
  button.toggleAttribute('aria-busy', state === 'busy');

  if (label) {
    label.textContent = state === 'added' ? button.dataset.addedLabel || 'Added' : button.dataset.label || '';
  }
}

document.addEventListener('shopify:cart:lines-update', (event) => {
  const button = buttonFor(event.target);
  if (!button) return;

  setState(button, 'busy');

  /** @type {Promise<any> | undefined} */
  const promise = /** @type {any} */ (event).promise;
  Promise.resolve(promise)
    .then((result) => {
      if (result?.detail?.didError) {
        setState(button, 'idle');
        return;
      }
      setState(button, 'added');
      setTimeout(() => setState(button, 'idle'), ADDED_FOR);
    })
    .catch(() => setState(button, 'idle'));
});

document.addEventListener('shopify:cart:error', (event) => {
  const button = buttonFor(event.target);
  if (button) setState(button, 'idle');
});
